<template>
  <nav class="hidden xl:block h-full flex-1">
    <ul class="flex h-full items-center flex-wrap overflow-hidden">
      <li v-for="(menu, index) in navigation" :key="`menu-${index}`" class="h-full">
        <DesktopMenuItem
          :navigation="menu"
          :is-open="currentItem ? currentItem.id === menu.id : false"
          @hover-item="handleMouseOver"
          @leave-item="handleMouseOut"
          @close="handleMouseOut"
          @hover-item-content="clearTimeouts"
        />
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import type { GQLNavigationItem } from './generated/page-header'
import DesktopMenuItem from './desktop-menu-item.vue'
import { NavigationMenuOpen } from '@core/analytics/core-events/navigation'

const UI_DELAY_PERIOD = 200
const TRACKING_DELAY_PERIOD = 500

defineProps<{ navigation: GQLNavigationItem[] }>()

const { $track } = useNuxtApp()

const currentItem = ref<GQLNavigationItem | null>(null)
const entryTimer = ref<ReturnType<typeof setTimeout> | null>(null)
const exitTimer = ref<ReturnType<typeof setTimeout> | null>(null)
const trackingTimer = ref<ReturnType<typeof setTimeout> | null>(null)

function clearTimeouts() {
  if (entryTimer.value) {
    clearTimeout(entryTimer.value)
  }

  if (exitTimer.value) {
    clearTimeout(exitTimer.value)
  }

  if (trackingTimer.value) {
    clearTimeout(trackingTimer.value)
  }
}

function handleMouseOver(item: GQLNavigationItem) {
  clearTimeouts()

  if (currentItem.value?.id === item.id) {
    return
  }

  entryTimer.value = setTimeout(
    () => {
      currentItem.value = item
    },
    currentItem.value ? 0 : UI_DELAY_PERIOD,
  )

  trackingTimer.value = setTimeout(() => {
    $track(NavigationMenuOpen(item.link.label)).catch(() => {
      // do nothing
    })
  }, TRACKING_DELAY_PERIOD)
}

function handleMouseOut() {
  clearTimeouts()
  exitTimer.value = setTimeout(() => {
    currentItem.value = null
  }, UI_DELAY_PERIOD * 2)
}
</script>
